import { Action } from '@ngrx/store';
import { Contacts, PendingContacts } from '@usimweb/core/models';

export const LOAD_CONTACTS = '[Contacts] Load contacts';
export const LOAD_CONTACTS_FAIL = '[Contacts] Load contacts Fail';
export const LOAD_CONTACTS_SUCCESS = '[Contacts] Load contacts Success';

export const LOAD_PROJECT_CONTACTS = '[Contacts] Load project contacts';
export const LOAD_PROJECT_CONTACTS_FAIL = '[Contacts] Load project contacts Fail';
export const LOAD_PROJECT_CONTACTS_SUCCESS = '[Contacts] Load project contacts Success';

export const DELETE_CONTACTS = '[Contacts] Delete contacts';
export const DELETE_CONTACTS_FAIL = '[Contacts] Delete contacts Fail';
export const DELETE_CONTACTS_SUCCESS = '[Contacts] Delete contacts Success';

export const CREATE_REQUEST = '[Contacts] Create request';
export const CREATE_REQUEST_FAIL = '[Contacts] Load request Fail';
export const CREATE_REQUEST_SUCCESS = '[Contacts] Load request Success';

export const LOAD_REQUESTS = '[Contacts] Load received requests';
export const LOAD_REQUESTS_FAIL = '[Contacts] Load received requests Fail';
export const LOAD_REQUESTS_SUCCESS = '[Contacts] Load received requests Success';

export const LOAD_REQUEST = '[Contacts] Load received request';
export const LOAD_REQUEST_FAIL = '[Contacts] Load received request Fail';
export const LOAD_REQUEST_SUCCESS = '[Contacts] Load received request Success';

export const LOAD_PENDING_REQUESTS = '[Contacts] Load pending requests';
export const LOAD_PENDING_REQUESTS_FAIL = '[Contacts] Load pending requests Fail';
export const LOAD_PENDING_REQUESTS_SUCCESS = '[Contacts] Load pending requests Success';

export const ACCEPT_INVITE = '[Contacts] Accept invite';
export const ACCEPT_INVITE_FAIL = '[Contacts] Accept invite Fail';
export const ACCEPT_INVITE_SUCCES = '[Contacts] Accept invite Success';

export const REJECT_INVITE = '[Contacts] Reject invite';
export const REJECT_INVITE_FAIL = '[Contacts] Reject invite Fail';
export const REJECT_INVITE_SUCCES = '[Contacts] Reject invite Success';

export class LoadContacts implements Action {
  readonly type = LOAD_CONTACTS;
}

export class LoadContactsFail implements Action {
  readonly type = LOAD_CONTACTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadContactsSuccess implements Action {
  readonly type = LOAD_CONTACTS_SUCCESS;
  constructor(public payload: Contacts[]) {}
}

//success and fail?
export class LoadProjectContacts implements Action {
  readonly type = LOAD_PROJECT_CONTACTS;
  constructor(public payload: string) {}
}

export class LoadProjectContactsFail implements Action {
  readonly type = LOAD_PROJECT_CONTACTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadProjectContactsSuccess implements Action {
  readonly type = LOAD_PROJECT_CONTACTS_SUCCESS;
  constructor(public payload: Contacts[]) {}
}

export class DeleteContacts implements Action {
  readonly type = DELETE_CONTACTS;
  constructor(public payload: string) {}
}

export class DeleteContactsFail implements Action {
  readonly type = DELETE_CONTACTS_FAIL;
  constructor(public payload: any) {}
}

export class DeleteContactsSuccess implements Action {
  readonly type = DELETE_CONTACTS_SUCCESS;
  constructor(public payload: string) {}
}

export class LoadRequests implements Action {
  readonly type = LOAD_REQUESTS;
}

export class LoadRequestsFail implements Action {
  readonly type = LOAD_REQUESTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadRequestsSuccess implements Action {
  readonly type = LOAD_REQUESTS_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadRequest implements Action {
  readonly type = LOAD_REQUEST;
  constructor(public payload: number) {}
}

export class LoadRequestFail implements Action {
  readonly type = LOAD_REQUEST_FAIL;
  constructor(public payload: any) {}
}

export class LoadRequestSuccess implements Action {
  readonly type = LOAD_REQUEST_SUCCESS;
  constructor(public payload: any) {}
}

export class CreateRequest implements Action {
  readonly type = CREATE_REQUEST;
  constructor(public payload: string) {}
}

export class CreateRequestFail implements Action {
  readonly type = CREATE_REQUEST_FAIL;
  constructor(public payload: any) {}
}

export class CreateRequestsSuccess implements Action {
  readonly type = CREATE_REQUEST_SUCCESS;
  // constructor(public payload: any) {}
}

export class LoadPendingRequests implements Action {
  readonly type = LOAD_PENDING_REQUESTS;
}

export class LoadPendingRequestsFail implements Action {
  readonly type = LOAD_PENDING_REQUESTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadPendingRequestsSuccess implements Action {
  readonly type = LOAD_PENDING_REQUESTS_SUCCESS;
  constructor(public payload: PendingContacts[]) {}
}

export class AcceptInvite implements Action {
  readonly type = ACCEPT_INVITE;
  constructor(public payload: number) {}
}

export class AcceptInviteSuccess implements Action {
  readonly type = ACCEPT_INVITE_SUCCES;
}

export class AcceptInviteFail implements Action {
  readonly type = ACCEPT_INVITE_FAIL;
  constructor(public payload: any) {}
}

export class RejectInvite implements Action {
  readonly type = REJECT_INVITE;
  constructor(public payload: number) {}
}

export class RejectInviteSuccess implements Action {
  readonly type = REJECT_INVITE_SUCCES;
}

export class RejectInviteFail implements Action {
  readonly type = REJECT_INVITE_FAIL;
  constructor(public payload: any) {}
}

export type ContactsAction =
  | LoadContacts
  | LoadContactsFail
  | LoadContactsSuccess
  | LoadProjectContacts
  | LoadProjectContactsFail
  | LoadProjectContactsSuccess
  | LoadRequests
  | LoadRequestsFail
  | LoadRequestsSuccess
  | LoadRequest
  | LoadRequestFail
  | LoadRequestSuccess
  | DeleteContacts
  | DeleteContactsFail
  | DeleteContactsSuccess
  | CreateRequest
  | CreateRequestFail
  | CreateRequestsSuccess
  | LoadPendingRequests
  | LoadPendingRequestsFail
  | LoadPendingRequestsSuccess
  | AcceptInvite
  | AcceptInviteFail
  | AcceptInviteSuccess
  | RejectInvite
  | RejectInviteFail
  | RejectInviteSuccess;
